import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { SIZE, Size } from 'models/Size';

import './CannotPreviewInBrowser.styles.scss';

type CannotPreviewInBrowserProps = {
  className?: string;
  size?: Size;
  showWeTriggerText?: boolean;
};

const CannotPreviewInBrowser: React.FC<CannotPreviewInBrowserProps> = (
  props,
) => {
  const {
    children,
    className,
    size = SIZE.BIG,
    showWeTriggerText = true,
  } = props;

  const classes = classNames('cannot-preview-in-browser', size, className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {children}
      <p>{t('thisTypeOfFileCantBeDisplayedInBrowser')}</p>
      {showWeTriggerText && <p>{t('soWeTriggerDownload')}</p>}
    </div>
  );
};

export default CannotPreviewInBrowser;
